// @ts-nocheck
import StoreCheckoutReviewAndSubmitReducer, {
    StoreCheckoutReviewAndSubmitActions,
} from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/StoreCheckoutReviewAndSubmitReducer";
import StoreOrderDetailsReducer, {
    StoreOrderDetailsActions,
} from "@store/Framework/Store/Store/Pages/OrderDetails/StoreOrderDetailsReducer";
import StoreProductWarrantyLookupReducer, {
    StoreProductWarrantyLookupActions,
} from "@store/Framework/Store/Store/Pages/ProductWarrantyLookup/StoreProductWarrantyLookupReducer";
import StoreRequestRmaPageReducer, {
    StoreRequestRmaPageActions,
} from "@store/Framework/Store/Store/Pages/RequestRma/RequestRmaPageReducer";
import StoreRfqQuoteDetailsReducer, {
    StoreRfqQuoteDetailsActions,
} from "@store/Framework/Store/Store/Pages/RfqQuoteDetails/StoreRfqQuoteDetailsReducer";
import StoreUserSetupReducer, {
    StoreUserSetupActions,
} from "@store/Framework/Store/Store/Pages/UserSetup/StoreUserSetupReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    requestRma: StoreRequestRmaPageReducer,
    checkoutReviewAndSubmit: StoreCheckoutReviewAndSubmitReducer,
    userSetup: StoreUserSetupReducer,
    productWarranty: StoreProductWarrantyLookupReducer,
    orderDetails: StoreOrderDetailsReducer,
    rfqQuoteDetails: StoreRfqQuoteDetailsReducer,
};

export type StorePagesActions =
    | StoreRequestRmaPageActions
    | StoreCheckoutReviewAndSubmitActions
    | StoreUserSetupActions
    | StoreProductWarrantyLookupActions
    | StoreOrderDetailsActions
    | StoreRfqQuoteDetailsActions;

export default combineReducers(pagesReducers);
